import axios from 'axios'
import { v4 as uuid } from 'uuid'

// Create or get session

let session = localStorage.getItem('swssAnalytics')
if (!session) {
  session = uuid()
  localStorage.setItem('swssAnalytics', session)
}

const analytics = {}

// Get session
analytics.session = () => session

// Create analytics event
analytics.event = (event, data1 = null, data2 = null) => {
  axios.post(`${process.env.VUE_APP_API}/analytics`, {
    session,
    platform: process.env.CORDOVA_PLATFORM ? 'app' : 'web',
    event,
    data1: data1 ? String(data1) : null,
    data2: data2 ? String(data2) : null
  })
    .then(() => false)
    .catch(() => console.warn('Error sending analytics data'))
}

export default analytics
